module.exports = __webpack_public_path__ + "img/store.be1d2728.svg";